module.exports = __webpack_public_path__ + "img/blend4icon3.35a8788c.png";